export default __webpack_public_path__ + "static/media/bookmarked-updated-ss.c02a6904.png";